import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const o = {
  data() {
    return {
      readUrl: '',
    };
  },
  methods: {
    downLoadPDF(pdfContentEl, docName, HEIGHT, total_pages) {
      const doc = new jsPDF()
      // console.log('jspdf', doc)
      console.log(pdfContentEl)
      const elWidth = pdfContentEl.clientWidth
      const elHeight = pdfContentEl.clientHeight
      console.log('元素宽高', elWidth, elHeight)
      if (!elHeight) return
      let scale = 1
      let num = 1
      if (total_pages && Number(total_pages)) {
        num = total_pages
        if (HEIGHT && Number(HEIGHT)) {
          scale = 1147 / (HEIGHT / num)
        }
      }
      console.log('页数', num)
      html2canvas(pdfContentEl, {
        width: elWidth, //dom 原始宽度
        height: elHeight,
        scrollY: 0, // html2canvas默认绘制视图内的页面，需要把scrollY，scrollX设置为0
        scrollX: 0,
        useCORS: true,
        scale,
      }).then(async canvas => {
        let width = canvas.width
        let height = canvas.height
        // let num = Math.ceil(height / 1147)
        // if (HEIGHT && Number(HEIGHT)) {
        //   num = Math.ceil(height / HEIGHT)
        // }
        // console.log('页数', num)
        console.log('画布宽高', width, height)
        this.readUrl = canvas.toDataURL('image/jpeg', 1.0)
        // console.log(this.readUrl)
        doc.addImage(this.readUrl, 'JPEG', 0, 0)
        if (num > 1) {
          for (let i = 1; i < num; i++) {
            doc.addPage()
            doc.addImage(this.readUrl, 'JPEG', 0, -(300 * i))
          }
        }
        await doc.save(docName);
      })
    },
  },
  mounted() { },
}

export default o